<template>
	<div
		v-editable="blok"
		class="px-4 md:px-8 py-6 rounded-2xl shadow-sm mb-6 md:mb-10"
		:class="bgColor"
	>
		<span v-if="blok.subtitle" class="text-body-tertiary mb-2 md:mb-4 block text-base">{{ blok.subtitle }}</span>
		<h3 v-if="blok.title" class="typo-h4 text-heading-primary mb-2 md:mb-4">
			{{ blok.title }}
		</h3>
		<RichText class="font-primary typo-body-m text-body-primary" :data="blok.content" />
	</div>
</template>

<script setup lang="ts">
	import type {HighlightedContentStoryblok} from '@/storyblok/types';

	interface Props {
		blok: HighlightedContentStoryblok
	}
	const props = defineProps<Props>();

	const bgColor = computed(() => {
		switch (props.blok.color) {
			case 'orange':
				return 'bg-brand-mujglobus-yellow-light';
			case 'green':
				return 'bg-brand-mujglobus-green-light';
			default:
				return 'bg-background-secondary';
		}
	});
</script>
